import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import Modal from "../Modal";
import { useModal } from "../../contexts/modal";
import service from "../../service";

const InteractionCard = ({ result, setInteractionCardResult }) => {
  // const [subscription, setSubscription] = useState(null);
  // const [typeformResponse, setTypeformResponse] = useState(null);
  // const [customFormResponse, setCustomFormResponse] = useState(null);
  const { openModal } = useModal();
  const flowTitle = result?.flowStage?.flow?.flowTitle || 'N/A'
  const flowStageTitle = result?.flowStage?.title || 'N/A'
  const flowStageType = result?.flowStage?.flowStageTypes?.name || 'N/A'
  const interactionCreatedAt = result?.createdAt ? DateTime.fromISO(result?.createdAt).toLocaleString(DateTime.DATETIME_MED) : 'N/A'

  return (
    <div
      onClick={() => {
        setInteractionCardResult(result)
        openModal()
      }}
      className='flex flex-col bg-white ring-1 ring-aoh-border dark:bg-zinc-800 dark:ring-0 rounded-lg dark:rounded px-3 py-2'
    >
      <div className='flex gap-2 text-sm'>
        <span className='font-bold'>Flow:</span>
        <span className=''>{flowTitle}</span>
      </div>

      <div className='flex gap-2 text-sm'>
        <span className='font-bold'>Stage:</span>
        <span className=''>{flowStageTitle}</span>
      </div>

      <div className='flex gap-2 text-sm'>
        <span className='font-bold'>Type:</span>
        <span className=''>{flowStageType}</span>
      </div>

      <div className='flex gap-2 text-sm'>
        <span className='font-bold'>Time:</span>
        <span className=''>{interactionCreatedAt}</span>
      </div>
    </div>
  );
};

export default InteractionCard;
